/* eslint-disable react/no-unstable-nested-components */
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useMatch,
} from 'react-router-dom';
import 'moment/locale/it';
import { Provider } from 'react-redux';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Toaster } from 'sonner';
import { store } from '../features/store';

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';

import 'react-day-picker/dist/style.css';
import './App.css';

import NotFound from '../common/components/NotFound';
import Login from '../screens/Login';
import RcProfession from '../screens/RcProfession';
import DashboardTheme from './theme/style-screens/DashboardTheme';
import RcQuotes from '../screens/RcQuotes';
import RcMotoQuotes from '../screens/RcMotoQuotes';
import RcProfessionQuotes from '../screens/RcProfessionQuotes';
import RequestListPage from '../screens/RequestsPage/RequestListPage';
import useAuth from '../hooks/useAuth';
import Profile from '../screens/Profile';
// import Tutorial from '../screens/Tutorial';
import ClaimsManagementReports from '../screens/ClaimsManagementReports';
// import Message from '../screens/Message';
// import MessageThread from '../screens/MessageThread';
import BrokerHome from '../screens/BrokerHome/BrokerHome';
import LatestUpdatesPage from '../screens/LatestUpdatesPage/LatestUpdatesPage';
import PurchasedQuotations from '../screens/PurchasedQuotations/PurchasedQuotations';
import Notifications from '../screens/Notifications';
import VehicleProduct from '../screens/VehicleProduct';
import CauzioniSubProducts from '../screens/cauzioni/CauzioniSubProducts';
import CauzioniRisks from '../screens/cauzioni/CauzioniRisks';
import CauzioniRequest from '../screens/cauzioni/CauzioniRequest';
import CauzioniResultPage from '../screens/cauzioni/CauzioniResultPage';
import BackOfficeCauzioni from '../screens/BackOffice/BackOfficeCauzioni';
import AccidentsPage from '../screens/AccidentsPage/AccidentsPage';
import AccidentPage from '../screens/AccidentPage/AccidentPage';
import TicketPage from '../screens/TicketPage';
import NetworkAnalisys from '../screens/ResearchScreens/NetworkAnalisys';
import ResearchType from '../screens/ResearchScreens/ResearchType';
import ComparativeAnalisys from '../screens/ResearchScreens/ComparativeAnalisys';
import CollaboratorsAnalisys from '../screens/ResearchScreens/CollaboratorsAnalisys';
import ListActiveCustomers from '../screens/ActiveCustomers/ListActiveCustomers';
import ActiveCustomerDetails from '../screens/ActiveCustomers/ActiveCustomerDetails';
import ReadGmail from '../screens/ActiveCustomers/ReadGmail';
import CustomerInformationPage from '../screens/ActiveCustomers/CustomerInformationPage';
// import Brokers from '../screens/BrokersPage/Brokers';
// import NewBroker from '../screens/BrokersPage/NewBroker';
// import EditBroker from '../screens/BrokersPage/EditBroker';
// import BrokerQuotations from '../screens/BrokersPage/BrokerQuotations';
// import { BrokersReports } from '../screens/BrokersPage/BrokersReports';
import ClientsListOfSezE from '../screens/ActiveCustomers/ClientsListOfSezE';
import { CancellationsPage } from '../screens/CancellationsPage/CancellationsPage';
import { CancellationPage } from '../screens/CancellationPage/CancellationPage';
import { ReplacmentsPage } from '../screens/ReplacementsPage/ReplacementsPage';
import { ReplacementPage } from '../screens/ReplacementPage/ReplacementPage';
import { ModificationsPage } from '../screens/ModificationsPage/ModificationsPage';
import { ModificationPage } from '../screens/ModificationPage/ModificationPage';
import { SendDocumentsPage } from '../screens/SendDocumentsPage/SendDocumentsPage';
import AuthenticateBackOffice from '../screens/BackOffice/AuthenticateBackOffice';
import BackOfficeRcVehicle from '../screens/BackOffice/BackOfficeRcVehicle';
import BackOfficeRcMoto from '../screens/BackOffice/BackOfficeRcMoto';
import BackOfficeRcVan from '../screens/BackOffice/BackOfficeRcVan';
import BackOfficeRcProfession from '../screens/BackOffice/BackOfficeRcProfession';
import BackOfficeInfortuni from '../screens/BackOffice/BackOfficeInfortuni';
import BackOfficeTravel from '../screens/BackOffice/BackOfficeTravel';
import BackOfficeVehicleQuotes from '../screens/BackOffice/results/BackOfficeVehicleQuotes';
import BackOfficeMotoQuotes from '../screens/BackOffice/results/BackOfficeMotoQuotes';
import BackofficeRcProfessionQuotes from '../screens/BackOffice/results/BackOfficeRcProfessionQuotes';
import BackOfficeInfortuniQuotes from '../screens/BackOffice/results/BackOfficeInfortuniQuotes';
import BackOfficeTravelQuotes from '../screens/BackOffice/results/BackOfficeTravelQuotes';
import { ForgotPassword } from '../screens/ForgotPassword';
import { ResetPassword } from '../screens/ResetPassword';
import { CreateReminder } from '../screens/Reminder/CreateReminder';
import { UpdateReminder } from '../screens/Reminder/UpdateReminder';
import { ContactCustomer } from '../screens/CommonCustomers/ContactCustomer';
import TravelFormFlow from '../screens/TravelProduct/TravelFormFlow';
import TravelResultPage from '../screens/TravelProduct/TravelResultPage';
import WidgetsScreen from '../screens/BrokerHome/WidgetsScreen';
import SelectPostVenditaAction from '../screens/SelectPostVenditaAction';
import SelectPostVenditaType from '../screens/SelectPostVenditaType';
import { ChangePassword } from '../screens/Auth/ChangePassword';
import SemestalityQuotesToBePaid from '../screens/PurchasedQuotations/SemestalityQuotesToBePaid';
import { Redirector } from '../screens/Redirector';
import Commercial from '../screens/Commercial';
import PurchaseCommercial from '../screens/purchase/PurchaseCommercial';
import RcCommercialQuotes from '../screens/RcCommercialQuotes';
import { TourProvider } from '../context/useTourContext';
import CommercialCompanyData from '../screens/Commercial/CommercialCompanyData';
import CommercialQuestionnaire from '../screens/Commercial/CommercialQuestionnaire';
import PurchaseProfessionalRequest from '../screens/purchase/PurchaseProfessionalRequest';
import PurchaseAutoRequest from '../screens/purchase/PurchaseAutoRequest';
import PurchaseAutocarroRequest from '../screens/purchase/PurchaseAutocarroRequest';
import PurchaseTravelRequest from '../screens/purchase/PurchaseTravelRequest';
import PurchaseMotoRequest from '../screens/purchase/PurchaseMotoRequest';
import ComponentRouteWrapper from '../screens/ComponentRouteWrapper';
import RcTutelaLegale from '../screens/RcTutelaLegale';
import RcTutelaLegaleQuotes from '../screens/RcTutelaLegaleQuotes';
import PurchaseTutelaLegaleRequest from '../screens/purchase/PurchaseTutelaLegaleRequest';
import AutoCompletedScreen from '../screens/CompletedQuotes/AutoCompletedScreen';
import ProfessionCompletedScreen from '../screens/CompletedQuotes/ProfessionCompletedScreen';
import TravelCompletedScreen from '../screens/CompletedQuotes/TravelCompletedScreen';
import TutelaLegaleCompletedScreen from '../screens/CompletedQuotes/TutelaLegaleCompletedScreen';
import MotoCompletedScreen from '../screens/CompletedQuotes/MotoCompletedScreen';
import Quote from '../screens/Quote';
import CommercialCompletedScreen from '../screens/CompletedQuotes/CommercialCompletedScreen';
import AssistenzaStradaleCompletedScreen from '../screens/CompletedQuotes/AssistenzaStradaleCompletedScreen';
import CristalliCompletedScreen from '../screens/CompletedQuotes/CristalliCompletedScreen';
import InfortuniConducenteCompletedScreen from '../screens/CompletedQuotes/InfortuniConducenteCompletedScreen';
import CollisioneCompletedScreen from '../screens/CompletedQuotes/CollisioneCompletedScreen';
import HomeFormFlow from '../screens/HouseProduct/HomeFormFlow';
import HomeResultPage from '../screens/HouseProduct/HomeResultPage';
import PurchaseHomeRequest from '../screens/HouseProduct/PurchaseHomeRequest';
import HomeCompletedScreen from '../screens/CompletedQuotes/HomeCompletedScreen';
import SaluteFormFlow from '../screens/SaluteProduct/SaluteFormFlow';
import SaluteResultPage from '../screens/SaluteProduct/SaluteResultPage';
import BackOfficeTutelaLegaleQuotes from '../screens/BackOffice/results/BackOfficeTutelaLegaleQuotes';
import BackOfficeHomeQuotes from '../screens/BackOffice/results/BackOfficeHomeQuotes';
import PurchaseSaluteRequest from '../screens/SaluteProduct/PurchaseSaluteRequest';
import SaluteCompletedScreen from '../screens/CompletedQuotes/SaluteCompletedScreen';
import BackOfficeSaluteQuotes from '../screens/BackOffice/results/BackOfficeSaluteQuotes';
import BackOfficeSalute from '../screens/BackOffice/BackOfficeSalute';
import ErrorComponentFallback from '../screens/ErrorComponentFallback';
import AncillariAutoFormFlow from '../screens/AncillariAutoProduct/AncillariAutoFormFlow';
import AncillariAutoResultPage from '../screens/AncillariAutoProduct/AncillariAutoResultPage';
import PurchaseAncillariAutoRequest from '../screens/AncillariAutoProduct/PurchaseAncillariAutoRequest';
import AncillariAutoCompletedScreen from '../screens/CompletedQuotes/AncillariAutoCompletedScreen';
import BackOfficeCommercialQuotes from '../screens/BackOffice/results/BackOfficeCommercialQuotes';
import BackOfficeAncillariAutoQuotes from '../screens/BackOffice/results/BackOfficeAncillariAutoQuotes';
import BackOfficeAncillari from '../screens/BackOffice/BackOfficeAncillari';
import BackOfficeHome from '../screens/BackOffice/BackOfficeHome';
import BackOfficeTutelaLegale from '../screens/BackOffice/BackOfficeTutelaLegale';
import FastQuotesPage from '../screens/FastQuotesPage/FastQuotesPage';
import CreateReplacement from '../screens/ReplacementPage/CreateReplacement';
import AfterSalePurchase from '../screens/AfterSalePurchase/AfterSalePurchase';
import CreateAccident from '../screens/AccidentPage/CreateAccident';
import NewCancellation from '../screens/CancellationPage/NewCancellation';
import { ModifyData } from '../screens/ModificationDataPage/ModificationData';
import CreateSuspension from '../screens/SuspensionsPages/CreateSuspension';
import SuspensionsList from '../screens/SuspensionsPages/SuspensionsList';
import SuspensionPage from '../screens/SuspensionsPages/SuspensionPage';
// import LuceGas from '../screens/LuceGas';
import SanitariaPerStranieriFormFlow from '../screens/SanitariaPerStranieriProduct/SanitariaPerStranieriFormFlow';
import SanitariaPerStranieriResultPage from '../screens/SanitariaPerStranieriProduct/SanitariaPerStranieriResultPage';
import PurchaseSanitariaStranieriRequest from '../screens/SanitariaPerStranieriProduct/PurchaseSanitariaStranieriRequest';
import SanitariaStranieriCompletedScreen from '../screens/CompletedQuotes/SanitariaStranieriCompletedScreen';
import BackOfficeSanitariaStranieri from '../screens/BackOffice/BackOfficeSanitariaStranieri';
import BackOfficeSanitariaStranieriQuotes from '../screens/BackOffice/results/BackOfficeSanitariaStranieriQuotes';
import ProfessionaleSanitaFormFlow from '../screens/RcProfessionaleSanita/ProfessionaleSanitaFormFlow';
import RcProfessionaleSanitaQuotes from '../screens/RcProfessionaleSanita/RcProfessionaleSanitaQuotes';
import ProfessioneSanitaQuotes from '../screens/RcProfessionaleSanita/ProfessioneSanitaQuotes';
import ProfessioneSanitaPurchase from '../screens/RcProfessionaleSanita/components/ProfessioneSanitaPurchase';
import ProfessionaleSanitaCompletedScreen from '../screens/RcProfessionaleSanita/ProfessionaleSanitaCompletedScreen';
import CommercialCompanyCatastrophe from '../screens/Commercial/CommercialCompanyCatastrophe';
import AiProducts from '../screens/AiGenerateProducts/AiProducts';
// import AiProductsList from '../screens/AiGenerateProducts/AiProductsList';
import AiProductChatShow from '../screens/AiGenerateProducts/AiProductChatShow';
import PurchaseOfflineRequest from '../screens/OfflineRequests/PurchaseOfflineRequest';
import OfflineCompletedScreen from '../screens/OfflineRequests/OfflineCompletedScreen';
import DocumentsUseful from '../screens/DocumentsUseful/DocumentsUseful';
import Luce from '../screens/LuceProduct/components/Luce';
import LuceFrame from '../screens/LuceProduct/LuceFrame';
// import GreeniaAiAgentsChat from '../screens/GreeniaAIAgents/GreeniaAiAgentsChat';
import Report from '../screens/BrokerReport/Report';
import { NewCommercialScreen } from '../screens/Commercial/NewCommercialScreen';
import PubblicoImpiegoFormFlow from '../screens/PubblicoImpiegoProduct/PubblicoImpiegoFormFlow';
import PubblicoImpiegoResultPage from '../screens/PubblicoImpiegoProduct/PubblicoImpiegoResultPage';
import PurchasePubblicoImpiegoRequest from '../screens/PubblicoImpiegoProduct/PurchasePubblicoImpiegoRequest';
import PubblicoImpiegoCompletedScreen from '../screens/CompletedQuotes/PubblicoImpiegoCompletedScreen';
import BackOfficePubblicoImpiegoQuotes from '../screens/BackOffice/results/BackOfficePubblicoImpiegoQuotes';
import BackOfficePubblicoImpiego from '../screens/BackOffice/BackOfficePubblicoImpiego';
import BackOfficeProfessioneSanitarie from '../screens/BackOffice/BackOfficeProfessioneSanitarie';
import BackOfficeProfessioneSanitaQuotes from '../screens/BackOffice/results/BackOfficeProfessioneSanitaQuotes';
import BackOfficeCommercialDefault from '../screens/BackOffice/BackOfficeCommercial';
import BackOfficeMediciDipendenti from '../screens/BackOffice/BackOfficeMediciDipendenti';
import BackOfficeProfessioneMediciLiberiProfessionisti from '../screens/BackOffice/BackOfficeProfessioneMediciLiberiProfessionisti';
import BackofficeMedicoProtetto from '../screens/BackOffice/BackofficeMedicoProtetto';
import BackOfficePatenteMotorTutela from '../screens/BackOffice/BackOfficePatenteMotorTutela';
import BackOfficeNucleoFamigliareTutela from '../screens/BackOffice/BackOfficeNucleoFamigliareTutela';
import MalattiaFormFlow from '../screens/MalattiaProduct/MalattiaFormFlow';
import MalattiaResultPage from '../screens/MalattiaProduct/MalattiaResultPage';
import PurchaseMalattiaRequest from '../screens/MalattiaProduct/PurchaseMalattiaRequest';
import MalattiaCompletedScreen from '../screens/CompletedQuotes/MalattiaCompletedScreen';
import BackofficeMalattia from '../screens/BackOffice/BackofficeMalattia';
import BackofficeMalattiaQuotes from '../screens/BackOffice/results/BackofficeMalattiaQuotes';
import InfortunioFormFlow from '../screens/InfortunioProduct/InfortunioFormFlow';
import InfortunioResultPage from '../screens/InfortunioProduct/InfortunioResultPage';
import PurchaseInfortunioRequest from '../screens/InfortunioProduct/PurchaseInfortunioRequest';
import InfortunioCompletedScreen from '../screens/CompletedQuotes/InfortunioCompletedScreen';
import BackofficeInfortunioQuotes from '../screens/BackOffice/results/BackofficeInfortunioQuotes';
import BackOfficeInfortunio from '../screens/BackOffice/BackOfficeInfortunio';
import CondominioFormFlow from '../screens/CondominioProduct/CondominioFormFlow';
import CondominioResultPage from '../screens/CondominioProduct/CondominioResultPage';
import PurchaseCondominioRequest from '../screens/CondominioProduct/PurchaseCondominioRequest';
import CondominioCompletedScreen from '../screens/CompletedQuotes/CondominioCompletedScreen';
import BackOfficeCondominioQuotes from '../screens/BackOffice/results/BackOfficeCondominioQuotes';
import BackOfficeCondominio from '../screens/BackOffice/BackOfficeCondominio';
import BackOfficeTutelaProfessionale from '../screens/BackOffice/BackOfficeTutelaProfessionale';
import RcFamigliaFormFlow from '../screens/RcFamigliaProduct/RcFamigliaFormFlow';
import RcFamigliaResultPage from '../screens/RcFamigliaProduct/RcFamigliaResultPage';
import PurchaseRcFamigliaRequest from '../screens/RcFamigliaProduct/PurchaseRcFamigliaRequest';
import BackofficeRcFamiglia from '../screens/BackOffice/BackofficeRcFamiglia';
import BackOfficeRcFamigliaQuotes from '../screens/BackOffice/results/BackOfficeRcFamigliaQuotes';
import Expirations from '../screens/Expirations';
import ExpirationDetails from '../screens/ExpirationDetails';
// import MonopattiniFormFlow from '../screens/MonopattiniElettrici/MonopattiniFormFlow';
import MonopattiniResultPage from '../screens/MonopattiniElettrici/MonopattiniResultPage';
import PurchaseMonopattiniRequest from '../screens/MonopattiniElettrici/PurchaseMonopattiniRequest';
import MonopattiniCompletedScreen from '../screens/CompletedQuotes/MonopattiniCompletedScreen';
import RcFamigliaCompletedScreen from '../screens/CompletedQuotes/RcFamigliaCompletedScreen';
import BackOfficeMonopattini from '../screens/BackOffice/BackOfficeMonopattini';
import BackOfficeMonopattiniQuotes from '../screens/BackOffice/results/BackOfficeMonopattiniQuotes';

const backofficeRoutes = [
  <Route
    path="/backoffice/:backOfficeAccessToken/:requestToken/:resultpage?"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <AuthenticateBackOffice />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/surety-bonds/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <CauzioniResultPage backoffice />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/surety-bonds"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeCauzioni />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/auto"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeRcVehicle />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/moto"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeRcMoto />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/autocarro"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeRcVan />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/profession"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeRcProfession />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/infortuni"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeInfortuni />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/travel"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeTravel />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/salute"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeSalute />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/tutela-legale/circolazione"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeTutelaLegale />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/tutela-legale/patente-motor"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficePatenteMotorTutela />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/tutela-legale/vita-privata"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeNucleoFamigliareTutela />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/tutela-legale/tutela-professionale"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeTutelaProfessionale />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/casa"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeHome />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/ancillari-auto"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeAncillari />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/sanitaria-stranieri"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeSanitariaStranieri />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/pubblico-impiego"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficePubblicoImpiego />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/malattia"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackofficeMalattia />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/condominio"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeCondominio />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/infortunio"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeInfortunio />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/rc-famiglia"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackofficeRcFamiglia />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/monopattini-elettrici"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeMonopattini />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/rc-professionale-sanita/professioni-sanitarie"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeProfessioneSanitarie />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/rc-professionale-sanita/medici-dipendenti"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeMediciDipendenti />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/rc-professionale-sanita/medici-liberi-professionisti"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeProfessioneMediciLiberiProfessionisti />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/rc-professionale-sanita/medico-protetto"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackofficeMedicoProtetto />
      </ErrorBoundary>
    )}
  />,

  <Route
    path="/backoffice/quote/:requestToken/tutela-legale/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeTutelaLegaleQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/commercial/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeCommercialQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/commercial"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeCommercialDefault />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/casa/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeHomeQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/salute/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeSaluteQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/rc-famiglia/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeRcFamigliaQuotes />
      </ErrorBoundary>
    )}
  />,

  <Route
    path="/backoffice/quote/:requestToken/monopattini-elettrici/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeMonopattiniQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/pubblico-impiego/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficePubblicoImpiegoQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/auto/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeVehicleQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/ancillari-auto/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeAncillariAutoQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/moto/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeMotoQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/autocarro/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeVehicleQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/profession/results"
    element={(
      // <ErrorBoundary
      //   fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      // >
      <BackofficeRcProfessionQuotes />
      // </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/infortuni/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeInfortuniQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/travel/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeTravelQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/sanitaria-stranieri/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeSanitariaStranieriQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/rc-professionale-sanita/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeProfessioneSanitaQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/malattia/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackofficeMalattiaQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/condominio/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackOfficeCondominioQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/backoffice/quote/:requestToken/infortunio/results"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <BackofficeInfortunioQuotes />
      </ErrorBoundary>
    )}
  />,
  <Route
    path="/redirect"
    element={(
      <ErrorBoundary
        fallbackRender={({ error }) => <ErrorComponentFallback error={error} />}
      >
        <Redirector />
      </ErrorBoundary>
    )}
  />,
];

function App() {
  const {
    isUserLoggedIn,
    //  isUserSectionAB
  } = useAuth();
  const matchBackoffice = useMatch('/backoffice/*');

  if (!isUserLoggedIn) {
    return (
      <Routes>
        <Route
          exact
          path="/"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <Navigate to="/login" />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/login"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <Login />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/auth/forgot"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ForgotPassword />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/auth/reset/:token"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ResetPassword />
            </ErrorBoundary>
          )}
        />

        {backofficeRoutes.map((c) => c)}

        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }

  if (matchBackoffice) {
    return (
      <Routes>
        {backofficeRoutes.map((c, index) => React.cloneElement(c, { key: index }))}
      </Routes>
    );
  }

  return (
    <DashboardTheme>
      <Routes>
        <Route
          path="/"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="dashboard_screen"
                returnComponent={<BrokerHome />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/dashboard"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="dashboard_screen"
                returnComponent={<BrokerHome />}
              />
            </ErrorBoundary>
          )}
        />

        {/* <Route
          path="/luce-gas"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="luce_gas_screen"
                returnComponent={<LuceGas />}
              />
            </ErrorBoundary>
          )}
        /> */}

        <Route
          path="/quote"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_products"
                returnComponent={<Quote />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quote/surety-bonds"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel"
                returnComponent={<CauzioniSubProducts />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quote/surety-bonds/:subProductSlug/request"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel"
                returnComponent={<CauzioniRequest />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quote/surety-bonds/:subProductSlug/risks"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel"
                returnComponent={<CauzioniRisks />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/surety-bonds/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="surety_bonds_result"
                returnComponent={<CauzioniResultPage />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quote/:vehicle/:fastQuoteId?"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel"
                returnComponent={<VehicleProduct />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quote/profession/:fastQuoteId?"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_professione_form"
                returnComponent={<RcProfession />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quote/commercial"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_commercial_form"
                returnComponent={<Commercial />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quote/quote-commercial"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <NewCommercialScreen />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quote/commercial/:vatNumber/report"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <CommercialCompanyData />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quote/commercial/:vatNumber/catastrophe"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <CommercialCompanyCatastrophe />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quote/commercial/:vatNumber/questionnaire/:company_id"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <CommercialQuestionnaire />
            </ErrorBoundary>
          )}
        />

        {/* OFFLINE REQUESTS */}
        <Route
          path="/quotes/offline/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <PurchaseOfflineRequest />
            </ErrorBoundary>
          )}
        />

        {/* HOUSE PRODUCT */}
        <Route
          path="/quote/casa/:fastQuoteId?"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_casa"
                returnComponent={<HomeFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        {/* POST VENDITA NEW CREATE SCREENS */}
        <Route
          path="/after-sale/new/replacement/:quoteId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="create_replacement_page"
                returnComponent={<CreateReplacement />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/after-sale/new/accident/:quoteId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="create_sinistro"
                returnComponent={<CreateAccident />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/after-sale/new/cancellation/:quoteId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="create_cancellation"
                returnComponent={<NewCancellation />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/after-sale/new/modify-data/:quoteId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="create_modify_data"
                returnComponent={<ModifyData />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/after-sale/new/suspension/:quoteId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="create_suspension"
                returnComponent={<CreateSuspension />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/after-sale/purchase/:afterSaleType/:afterSaleId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="purchase_after_sale_page"
                returnComponent={<AfterSalePurchase />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/casa/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="casa_result"
                returnComponent={<HomeResultPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/casa/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_casa_purchase"
                returnComponent={<PurchaseHomeRequest />}
              />
            </ErrorBoundary>
          )}
        />

        {/* SALUTE PRODUCT */}
        <Route
          path="/quote/salute"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_salute"
                returnComponent={<SaluteFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/salute/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="salute_result"
                returnComponent={<SaluteResultPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/salute/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_salute_purchase"
                returnComponent={<PurchaseSaluteRequest />}
              />
            </ErrorBoundary>
          )}
        />

        {/* PUBBLICO IMPIEGO PRODUCT */}
        <Route
          path="/quote/pubblico-impiego"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_pubblico_impiego"
                returnComponent={<PubblicoImpiegoFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/pubblico-impiego/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="pubblico_impiego_result"
                returnComponent={<PubblicoImpiegoResultPage />}
              />

            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/pubblico-impiego/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_pubblico_impiego_purchase"
                returnComponent={<PurchasePubblicoImpiegoRequest />}
              />
            </ErrorBoundary>
          )}
        />

        {/* Malattia PRODUCT */}
        <Route
          path="/quote/malattia"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_malattia"
                returnComponent={<MalattiaFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/malattia/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="malattia_result"
                returnComponent={<MalattiaResultPage />}
              />

            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/malattia/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_malattia_purchase"
                returnComponent={<PurchaseMalattiaRequest />}
              />
            </ErrorBoundary>
          )}
        />

        {/* Infortunio PRODUCT */}
        <Route
          path="/quote/infortunio"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_infortunio"
                returnComponent={<InfortunioFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/infortunio/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="infortunio_result"
                returnComponent={<InfortunioResultPage />}
              />

            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/infortunio/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_infortunio_purchase"
                returnComponent={<PurchaseInfortunioRequest />}
              />
            </ErrorBoundary>
          )}
        />

        {/* Condominio PRODUCT */}
        <Route
          path="/quote/condominio/:fastQuoteId?"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_condominio"
                returnComponent={<CondominioFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/condominio/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="condominio_result"
                returnComponent={<CondominioResultPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/condominio/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_condominio_purchase"
                returnComponent={<PurchaseCondominioRequest />}
              />
            </ErrorBoundary>
          )}
        />

        {/* Rc Famiglia PRODUCT */}
        <Route
          path="/quote/rc-famiglia/:fastQuoteId?"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_rc_famiglia"
                returnComponent={<RcFamigliaFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/rc-famiglia/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="rc_famiglia_result"
                returnComponent={<RcFamigliaResultPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/rc-famiglia/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_condominio_purchase"
                returnComponent={<PurchaseRcFamigliaRequest />}
              />
            </ErrorBoundary>
          )}
        />

        {/* Sanitaria per Stranieri */}
        <Route
          path="/quote/sanitaria-stranieri"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_sanitaria_per_stranieri"
                returnComponent={<SanitariaPerStranieriFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/sanitaria-stranieri/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="sanitaria_per_stranieri_result"
                returnComponent={<SanitariaPerStranieriResultPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/sanitaria-stranieri/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_sanitaria_stranieri_purchase"
                returnComponent={<PurchaseSanitariaStranieriRequest />}
              />
            </ErrorBoundary>
          )}
        />

        {/* Monopattini Elettrici PRODUCT */}
        {/* <Route
          path="/quote/monopattini-elettrici"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_monopattini_elettrici"
                returnComponent={<MonopattiniFormFlow />}
              />
            </ErrorBoundary>
          )}
        /> */}
        <Route
          path="/quotes/monopattini-elettrici/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="monopattini_version_result"
                returnComponent={<MonopattiniResultPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/monopattini-elettrici/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_monopattini_purchase"
                returnComponent={<PurchaseMonopattiniRequest />}
              />
            </ErrorBoundary>
          )}
        />

        {/* ANCILLARI AUTO PRODUCT */}
        <Route
          path="/quote/ancillari-auto"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_ancillari_auto"
                returnComponent={<AncillariAutoFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/ancillari-auto/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="ancillari_auto_result"
                returnComponent={<AncillariAutoResultPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/ancillari-auto/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_ancillari_auto_purchase"
                returnComponent={<PurchaseAncillariAutoRequest />}
              />
            </ErrorBoundary>
          )}
        />

        {/* <Route path="/quote/metlife" element={<Metlife />} />
        <Route path="/quote/metlife/:pack" element={<Metlife />} /> */}
        <Route
          path="/quote/travel/:fastQuoteId?"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_travel_form"
                returnComponent={<TravelFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/travel/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_travel_result"
                returnComponent={<TravelResultPage />}
              />
            </ErrorBoundary>
          )}
        />
        {/* <Route path="/quotes/travel/purchase/:quotationId" element={<PurchaseTravel />} /> */}
        <Route
          path="/quotes/travel/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_travel_purchase"
                returnComponent={<PurchaseTravelRequest />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/travel"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_travel_completed_screen"
                returnComponent={<TravelCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/offline"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_offline_completed_screen"
                returnComponent={<OfflineCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_auto_result"
                returnComponent={<RcQuotes />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/moto/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_moto_result"
                returnComponent={<RcMotoQuotes />}
              />
            </ErrorBoundary>
          )}
        />

        {/* <Route
          path="/quotes/metlife/:requestToken"
          element={<MetlifeQuote />}
        /> */}

        {/* Rc Professionale Sanita PRODUCT */}
        <Route
          path="/quote/rc-professionale-sanita"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_rc_professionale_sanita"
                returnComponent={<RcProfessionaleSanitaQuotes />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quote/rc-professionale-sanita/:sub_product/:fastQuoteId?"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="funnel_rc_professionale_sanita_sub_product"
                returnComponent={<ProfessionaleSanitaFormFlow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/rc-professionale-sanita/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="rc_professionale_sanita_result"
                returnComponent={<ProfessioneSanitaQuotes />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/rc-professionale-sanita/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_rc_professionale_sanita_purchase"
                returnComponent={<ProfessioneSanitaPurchase />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/purchased/:quoteId/quotation/rc-professionale-sanita"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_rc_professionale_sanita_purchased"
                returnComponent={<ProfessionaleSanitaCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/profession/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_professione_result"
                returnComponent={<RcProfessionQuotes />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/commercial/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_commercial_result"
                returnComponent={<RcCommercialQuotes />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quote/luce"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="luce"
                returnComponent={<Luce />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quote/luce/frame"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="luce_frame"
                returnComponent={<LuceFrame />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/commercial"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_commercial_completed_screen"
                returnComponent={<CommercialCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        {/* tutela legale */}
        <Route
          path="/quote/tutela-legale/:subProduct?"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_tutela_legale_form"
                returnComponent={<RcTutelaLegale />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/tutela-legale/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_tutela_legale_result"
                returnComponent={<RcTutelaLegaleQuotes />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/tutela-legale/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_tutela_legale_purchase"
                returnComponent={<PurchaseTutelaLegaleRequest />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/tutela-legale"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_tutela_legale_completed_screen"
                returnComponent={<TutelaLegaleCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/assistenza-stradale"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_assistenza_stradale_completed_screen"
                returnComponent={<AssistenzaStradaleCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/cristalli"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_cristalli_completed_screen"
                returnComponent={<CristalliCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/infortuni-conducente"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_infortuni_conducente_completed_screen"
                returnComponent={<InfortuniConducenteCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        {/* <Route
          path="/quotes/metlife/purchase/:quotationId"
          element={<PurchaseInfortuni />}
        /> */}
        <Route
          path="/quotes/auto/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_auto_purchase"
                returnComponent={<PurchaseAutoRequest />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/auto"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_auto_completed_screen"
                returnComponent={<AutoCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/purchased/:quoteId/quotation/casa"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_casa_completed_screen"
                returnComponent={<HomeCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/purchased/:quoteId/quotation/salute"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_salute_completed_screen"
                returnComponent={<SaluteCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/purchased/:quoteId/quotation/ancillari-auto"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_ancillari_auto_completed_screen"
                returnComponent={<AncillariAutoCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/sanitaria-stranieri"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_sanitaria_stranieri_completed_screen"
                returnComponent={<SanitariaStranieriCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/purchased/:quoteId/quotation/autocarro"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_autocarro_completed_screen"
                returnComponent={<AutoCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/purchased/:quoteId/quotation/moto"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_moto_completed_screen"
                returnComponent={<MotoCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/collisione"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_collisione_completed_screen"
                returnComponent={<CollisioneCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/purchased/:quoteId/quotation/pubblico-impiego"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_pubblico_impiego_completed_screen"
                returnComponent={<PubblicoImpiegoCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/purchased/:quoteId/quotation/malattia"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_malattia_completed_screen"
                returnComponent={<MalattiaCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/purchased/:quoteId/quotation/infortunio"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_infortunio_completed_screen"
                returnComponent={<InfortunioCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/purchased/:quoteId/quotation/condominio"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_condominio_completed_screen"
                returnComponent={<CondominioCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/rc-famiglia"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_rc_famiglia_completed_screen"
                returnComponent={<RcFamigliaCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/monopattini-elettrici"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_monopattini_elettrici_completed_screen"
                returnComponent={<MonopattiniCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/quotes/moto/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_moto_purchase"
                returnComponent={<PurchaseMotoRequest />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/autocarro/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_autocarro_purchase"
                returnComponent={<PurchaseAutocarroRequest />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/ai-products"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="ai_products_chat"
                returnComponent={<AiProducts />}
              />
            </ErrorBoundary>
          )}
        />
        {/* <Route
          path="/ai-products-list"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="ai_products_chat_list"
                returnComponent={<AiProductsList />}
              />
            </ErrorBoundary>
          )}
        /> */}
        <Route
          path="/expirations"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="expirations_list"
                returnComponent={<Expirations />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/expirations-details"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="expirations_list"
                returnComponent={<ExpirationDetails />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/ai-products-chat/:threadId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="ai_products_chat_show"
                returnComponent={<AiProductChatShow />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/profession/purchase/:requestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_profession_purchase"
                returnComponent={<PurchaseProfessionalRequest />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/purchased/:quoteId/quotation/profession"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_profession_completed_screen"
                returnComponent={<ProfessionCompletedScreen />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quotes/commercial/purchase/:insuranceRequestToken"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="quotation_commercial_purchase"
                returnComponent={<PurchaseCommercial />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/profile"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="broker_profile"
                returnComponent={<Profile />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/useful-documents"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="useful_documents"
                returnComponent={<DocumentsUseful />}
              />
            </ErrorBoundary>
          )}
        />
        {/* <Route
          path="/tutorial"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="tutorial"
                returnComponent={<Tutorial />}
              />
            </ErrorBoundary>
          )}
        /> */}
        <Route
          path="/quotazioni-aquistati"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="purchased_quotation_list"
                returnComponent={<PurchasedQuotations />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/quote-semestrale-da-pagare"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="semestrality_quotation_list"
                returnComponent={<SemestalityQuotesToBePaid />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/post-vendita"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="post_vendita_actions"
                returnComponent={<SelectPostVenditaAction />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/after-sale"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="after_sale_list"
                returnComponent={<ClaimsManagementReports />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/after-sale/select"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="select_after_sale"
                returnComponent={<SelectPostVenditaType />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/accidents"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="accidents_list"
                returnComponent={<AccidentsPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/accidents/:accidentId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="accident_single_page"
                returnComponent={<AccidentPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/cancellations"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="cancellations_list"
                returnComponent={<CancellationsPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/cancellations/:cancellationId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="cancellation_single_page"
                returnComponent={<CancellationPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/replacements"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="replacements_list"
                returnComponent={<ReplacmentsPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/replacements/:replacementId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="replacement_single_page"
                returnComponent={<ReplacementPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/modifications"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="modifications_list"
                returnComponent={<ModificationsPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/modifications/:modificationId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="modification_single_page"
                returnComponent={<ModificationPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/send-documents"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="send_documents_list"
                returnComponent={<SendDocumentsPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/suspensions"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="suspensions_list"
                returnComponent={<SuspensionsList />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/suspensions/:suspensionId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="suspension_single_page"
                returnComponent={<SuspensionPage />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/notifications"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="notifications"
                returnComponent={<Notifications />}
              />
            </ErrorBoundary>
          )}
        />

        {/* Active Customers */}
        <Route
          path="/clients"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="clients_list"
                returnComponent={<ListActiveCustomers />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/clients/rete"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="clients_of_sez_E_list"
                returnComponent={<ClientsListOfSezE />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/clients/:activeClientId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="active_client_single_page"
                returnComponent={<ActiveCustomerDetails />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/clients/email/:gmailId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ReadGmail />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/clients-not-active/:customerId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="non_active_client_single_page"
                returnComponent={<CustomerInformationPage />}
              />
            </ErrorBoundary>
          )}
        />
        {/* Messages Routes */}
        {/* <Route
          path="/messages"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="messages"
                returnComponent={<Message />}
              />
            </ErrorBoundary>
          )}
        /> */}
        {/* <Route
          path="/messages/:threadId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="thread_single_page"
                returnComponent={<MessageThread />}
              />
            </ErrorBoundary>
          )}
        /> */}

        {/** Latest Updates Routes */}
        <Route
          path="/latest-updates"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="latest_update"
                returnComponent={<LatestUpdatesPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/fast-quotes"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="fast-quotes"
                returnComponent={<FastQuotesPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/preventivi"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="preventivi"
                returnComponent={<RequestListPage />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/report"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="broker-report"
                returnComponent={<Report />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/tickets/:ticketId"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="ticket_single_page"
                returnComponent={<TicketPage />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/research-type"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="research_type"
                returnComponent={<ResearchType />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/network-analisys"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="network_analisys"
                returnComponent={<NetworkAnalisys />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/comparative-analisys"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="comparative_analisys"
                returnComponent={<ComparativeAnalisys />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/collaborators-analisys"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="collaborators_analisys"
                returnComponent={<CollaboratorsAnalisys />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/reminders/create"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="create_reminder"
                returnComponent={<CreateReminder />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/reminders/:reminderId/edit"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="update_reminder"
                returnComponent={<UpdateReminder />}
              />
            </ErrorBoundary>
          )}
        />
        <Route
          path="/customers/:type/:customerId/contact"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="contact_customer"
                returnComponent={<ContactCustomer />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/widgets"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="widgets"
                returnComponent={<WidgetsScreen />}
              />
            </ErrorBoundary>
          )}
        />

        <Route
          path="/security/change/password"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="change_password"
                returnComponent={<ChangePassword />}
              />
            </ErrorBoundary>
          )}
        />
        {/* <Route
          path="/work-in-progress"
          element={(
            <ComponentRouteWrapper
              location="work-in-progress"
              returnComponent={<ErrorComponentFallback />}
            />
          )}
        /> */}

        <Route
          path="/redirect"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <Redirector />
            </ErrorBoundary>
          )}
        />

        {/* {isUserSectionAB && (
          <>
            <Route
              path="/brokers"
              element={(
                <ErrorBoundary
                  fallbackRender={({ error }) => (
                    <ErrorComponentFallback error={error} />
                  )}
                >
                  <ComponentRouteWrapper
                    location="brokers_list"
                    returnComponent={<Brokers />}
                  />
                </ErrorBoundary>
              )}
            />
            <Route
              path="/brokers/new"
              element={(
                <ErrorBoundary
                  fallbackRender={({ error }) => (
                    <ErrorComponentFallback error={error} />
                  )}
                >
                  <ComponentRouteWrapper
                    location="create_broker"
                    returnComponent={<NewBroker />}
                  />
                </ErrorBoundary>
              )}
            />
            <Route
              path="/brokers/:brokerId"
              element={(
                <ErrorBoundary
                  fallbackRender={({ error }) => (
                    <ErrorComponentFallback error={error} />
                  )}
                >
                  <ComponentRouteWrapper
                    location="edit_broker"
                    returnComponent={<EditBroker />}
                  />
                </ErrorBoundary>
              )}
            />
            <Route
              path="/brokers/:brokerId/quotations"
              element={(
                <ErrorBoundary
                  fallbackRender={({ error }) => (
                    <ErrorComponentFallback error={error} />
                  )}
                >
                  <ComponentRouteWrapper
                    location="broker_quotations"
                    returnComponent={<BrokerQuotations />}
                  />
                </ErrorBoundary>
              )}
            />
            <Route
              path="/brokers-reports"
              element={(
                <ErrorBoundary
                  fallbackRender={({ error }) => (
                    <ErrorComponentFallback error={error} />
                  )}
                >
                  <ComponentRouteWrapper
                    location="broker_reports"
                    returnComponent={<BrokersReports />}
                  />
                </ErrorBoundary>
              )}
            />
          </>
        )} */}

        {/* <Route
          path="/ai-agent-greenia"
          element={(
            <ErrorBoundary
              fallbackRender={({ error }) => (
                <ErrorComponentFallback error={error} />
              )}
            >
              <ComponentRouteWrapper
                location="ai_agent_greenia_chat"
                returnComponent={<GreeniaAiAgentsChat />}
              />
            </ErrorBoundary>
          )}
        /> */}

        <Route path="*" element={<NotFound />} />
      </Routes>
    </DashboardTheme>
  );
}

function AppWrapper() {
  return (
    <TourProvider>
      <Provider store={store}>
        <Router>
          <App />
          <Toaster richColors theme="light" closeButton />
        </Router>
      </Provider>
    </TourProvider>
  );
}

export default AppWrapper;
